import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// TODO: Delete this route when clean up timeline harmonisation M3 (fg: jira_timeline_harmonisation_m3)
export const projectSettingsSoftwareBoardsTimelineRoute: InvariantJiraRoute = {
	name: 'project-settings-software-boards-timeline',
	path: '/jira/software/projects/:projectKey/settings/boards/:boardId/timeline',
	exact: true,
};
